import IngredientsAdding from "./IngredientsAdding";
import common from "../../../common";
import Ingredient from "../Ingredient";

export default class Secondary_Ingredients extends IngredientsAdding {
    constructor(requiredItems) {
        super();
        this._request = null;
        this._requiredItems = [];
        this._wantsItem = false;
        this._mixtureColours = [];
    }

    init(bowlPosition) {
        this.determineRequest();
        this._bowlPosition = bowlPosition;
        this.createIngredients();
        this.animateInIngredients();
    }

    update() {
        super.update();
    }

    createIngredients(){
        //console.log("secondary init");
        let selectedItems = [];
        let all = [];

        let remove = (item, array) =>{
            for (let i = 0; i < array.length; i++) {
                const arrayElement = array[i];
                if(arrayElement === item) {
                    array.splice(i, 1);
                    break;
                }
            }
        };
        let convertJsonToArray = (jsonArray)=>{
            const jsonData = jsonArray;
            let tempArray = [];
            for (const i in jsonData) {
                if (jsonData.hasOwnProperty(i)) {
                    tempArray.push(jsonData[i]);
                }
            }
            return tempArray;
        };


        this._request = common.selectedCharacter.getRequest();

        let items = convertJsonToArray(this._requiredItems);
        this._requiredItems = items;
        all = convertJsonToArray(common.selectedRecipeBuild.secondaryIngredients);

        if(this._request.type === "ingredient"){
            selectedItems.push(all.find((element)=>{
                if(element.img.toString() === items[0])
                    return element;
            }));

            let index = all.indexOf(selectedItems[0]);
            all.splice(index,1);
        }

        if(selectedItems.length < 5){
            for (let i = 0; selectedItems.length < 5; i++) {
                let item = common.randomSelection(all);
                selectedItems.push(item);
                remove(item, all);
            }
            common.shuffle(selectedItems);
        }

        let offset = 10;
        const numOfIngredients = selectedItems.length;

        for (let i = 0; i < selectedItems.length; i++) {

            const selectedItem = selectedItems[i];

            const emitterTexture = [];
            const textures = selectedItem.emitterTexture;
            for (const i in textures) {
                if (textures.hasOwnProperty(i)) {
                    emitterTexture.push(textures[i]);
                }
            }

            let emptyTex = "";
            emptyTex = selectedItem.img[0].slice(0, -5) + "used";
            let item = new Ingredient({
                shelf: P3.assets.texture(selectedItem.img[0]),
                empty: P3.assets.texture(emptyTex)
            }, {
                x: 400 + (offset - 100),
                y: common.getRandomInt(0, -300)
            }, selectedItem.emitter, emitterTexture);

            item.id = i;
            item._name = selectedItem.img;
            item._animIn = this.animateIngredients(item, {
                x: 400 + offset,
                y: 300
            }, 1000);
            item._respawnPosition = {x: 400 + offset, y: 300};
            item._colour = selectedItem.colour;
            this._mixtureColours.push(item._colour);

            this._bindings[item + i + 'dragStart'] = item.signals.dragStart.add(()=>{
                this._innerContainer.removeChild(item);
                this._innerContainer.addChild(item);
                if(this._tutorialFinger)
                    this._tutorialFinger.turnOff();
            }, this);
            this._bindings[item + i + 'dragEnd'] = item.signals.dragEnd.add((sprite)=>{
                if(this.checkIngredientBounds(sprite)){
                    for (const ingredient of this._ingredients) {
                        ingredient.removeInteractions();
                    }
                }

            }, this);
            this._bindings[item + i + 'remove'] = item.signals.remove.add(this.removeIngredients, this);

            this._ingredients.unshift(item);
            this._tutorialPositions.unshift(item._respawnPosition);
            this._innerContainer.addChild(item);

            offset += common.STAGE_HEIGHT / numOfIngredients - 10;
        }

        this._ingredientIndex = this._ingredients.length - 1;
        this.removeTutorialFinger();
    }

    removeIngredients(id){
        let colour = "";

        for (let i = 0; i < this._ingredients.length; i++) {
            if (this._ingredients[i].id === id) {
                const temp = this._ingredients[i];
                colour = temp._colour;
                temp.floatBackAnimation();

                for (let j = 0; j < this._requiredItems.length; j++) {
                    const requiredItem = this._requiredItems[j];
                    if(temp._name.toString() === requiredItem.toString()){
                        this._requiredItems.splice(j,1);
                        //break;
                    }
                }
            }
        }
        this._signals.ingredientRemoved.dispatch(colour);
        this._signals.stageComplete.dispatch();
        this._bindings.help.detach();

        this.removeTutorialFinger();

        let sounds = ['sfx_add_ingredient_00', 'sfx_add_ingredient_01', 'sfx_add_ingredient_02'];
        P3.audio.playSound(common.randomSelection(sounds));

        if(this._request.type === "ingredient"){
           // console.log(this._requiredItems);
            if(this._wantsItem){
                common.selectedCharacter._requestCompleted = this._requiredItems.length <= 0;
            }else{
                common.selectedCharacter._requestCompleted = this._requiredItems.length > 0;
            }
           // console.log(common.selectedCharacter._requestCompleted);
        }
    }

    determineRequest(){
        let request = common.selectedCharacter.getRequest();
        if(request.type !== "ingredient") return;

        this._requiredItems = request.requestedParts;
        this._wantsItem = request.wants;
    }
}